import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import Status from '../../../../UI/status/Status'
import ChangeStatusOrderForm from './ChangeStatusOrderForm'

const ChangeStatusOrderButton = ({ supplyOrder, status }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <button
            onClick={e => setOpen(true)}
        >
            <Status 
                status={supplyOrder.status} 
            />
        </button>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Зміна статусу заявки'}
            disableClickOutside={true}
            content={
                <ChangeStatusOrderForm
                    supplyOrderBd={supplyOrder}
                    // userBd={user}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeStatusOrderButton